import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';

import { Model, ModelFactory } from '@angular-extensions/model';

import { SimilarSearchModel, ISimilarSearchModel } from '../models/similar-search-model';
import { ISearchResultModel } from '../models/search-result-model';
import { SimilarSearchToken, ISimilarSearchService } from './isimilar-search.service';

const initialData: ISimilarSearchModel = SimilarSearchModel.empty();

@Injectable(/*{
  providedIn: 'root' // keep it local
}*/)
export class SimilarVehicleService {
  private _model: Model<ISimilarSearchModel>;

  active$: Observable<ISimilarSearchModel>;

  constructor(
    private _modelFactory: ModelFactory<ISimilarSearchModel>,
    @Inject(SimilarSearchToken) private similarSearchService: ISimilarSearchService
  ) {

    this._model = this._modelFactory.create(initialData);
    this.active$ = this._model.data$;
  }

  update(model: ISimilarSearchModel): void {
    this._model.set(model);
  }

  linked(model: ISimilarSearchModel): Observable<ISearchResultModel> {
    return this.similarSearchService.linkedSearch(model);
  }

  similar(model: ISimilarSearchModel): Observable<ISearchResultModel> {
    return this.similarSearchService.similarSearch(model);
  }
}
